import { zodResolver } from "@hookform/resolvers/zod";
import { Save, X } from "lucide-react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { EnumSelect } from "@/components/shared/enum-select";
import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { ORDER_STATUS_OPTIONS, ORDER_STATUSES } from "@/lib/enums";

const orderEditSchema = z.object({
  status: z.enum(ORDER_STATUSES),
});

type OrderEditValues = z.infer<typeof orderEditSchema>;

interface OrderEditFormProps {
  status: string;
  onSave: (updates: OrderEditValues) => void;
  onCancel: () => void;
  isSaving: boolean;
}

export function OrderEditForm({ status, onSave, onCancel, isSaving }: OrderEditFormProps) {
  const form = useForm<OrderEditValues>({
    resolver: zodResolver(orderEditSchema),
    defaultValues: {
      status: status as OrderEditValues["status"],
    },
  });

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSave)} className="space-y-4">
        <FormField
          control={form.control}
          name="status"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Status</FormLabel>
              <FormControl>
                <EnumSelect
                  value={field.value}
                  onValueChange={field.onChange}
                  options={ORDER_STATUS_OPTIONS}
                  className="w-[180px]"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <div className="flex gap-2 justify-end">
          <Button type="button" variant="ghost" size="sm" onClick={onCancel}>
            <X className="h-4 w-4 mr-1" />
            Cancel
          </Button>
          <Button type="submit" size="sm" disabled={isSaving}>
            <Save className="h-4 w-4 mr-1" />
            {isSaving ? "Saving…" : "Save"}
          </Button>
        </div>
      </form>
    </Form>
  );
}
